import React from "react";
import styled from "styled-components";
import { color, font } from "../templates/ui";
import ErrorLabel from "./ErrorLabel";
import _ from "lodash";

const StyledInputItem = styled.div`
  position: relative;
  display: block;
  margin-bottom: 20px;

  &:before {
    position: absolute;
    content: "";
    top: 1px;
    left: 1px;
    border-radius: 5px 5px 0 0;
    width: calc(100% - 2px);
    height: 23px;
    background-color: #ffffff;
    z-index: 1;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

const StyledInput = styled.textarea`
  transition: border-color 0.2s ease-in-out;
  padding: 30px 20px 16px 10px;
  margin: 0;
  background-color: transparent;
  border: 1px solid #b2babf;
  width: 100%;
  min-height: 200px;
  box-sizing: border-box;
  outline: none;
  font-size: 15px;
  line-height: 1.2rem;
  color: #69696f;
  border-radius: 4px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  resize: none;

  &[type="number"]::-webkit-inner-spin-button,
  &[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &::-webkit-input-placeholder {
    opacity: 1;
    transition: all 0.2s;
  }

  &::-moz-placeholder {
    opacity: 1;
    transition: all 0.2s;
  }

  &:-ms-input-placeholder {
    opacity: 1;
    transition: all 0.2s;
  }

  &::placeholder {
    opacity: 1;
    transition: all 0.2s;
  }

  &:placeholder-shown:not(:focus)::-webkit-input-placeholder {
    opacity: 0;
  }

  &:placeholder-shown:not(:focus)::-moz-placeholder {
    opacity: 0;
  }

  &:placeholder-shown:not(:focus):-ms-input-placeholder {
    opacity: 0;
  }

  &:placeholder-shown:not(:focus)::placeholder {
    opacity: 0;
  }

  &:placeholder-shown:not(:focus) + * {
    font-size: 16px;
    top: 16px;
    color: #69696f;
    font-weight: 400;
  }

  &:disabled {
    background-color: #eeeeee;
    cursor: default;

    + label {
      opacity: 0.5;
    }
  }
`;

const IconWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
`;

const StyledLabel = styled.label`
  position: absolute;
  top: 7px;
  left: 10px;
  pointer-events: none;
  color: ${props => props.theme.tertiary};
  font-weight: 600;
  font-family: ${props => props.theme.fontBase};
  transition: all 0.2s;
  font-size: 85%;
  opacity: 1;
  cursor: text;
  z-index: 2;
`;

const InputTextArea = ({
  id,
  className,
  icon,
  value,
  label,
  placeholder,
  floatingLabel,
  error,
  ...props
}) => {
  return (
    <>
      <StyledInputItem className={className} icon={icon}>
        <StyledInput
          {...props}
          placeholder=" "
          floatingLabel={floatingLabel}
          value={value}
          icon={icon}
          error={error}
          id={id}
        />
        <StyledLabel htmlFor={id} error={error}>
          {label}
        </StyledLabel>
        <IconWrapper>{icon}</IconWrapper>
        {!!error && <ErrorLabel>{_.capitalize(error)}</ErrorLabel>}
      </StyledInputItem>
    </>
  );
};

export default InputTextArea;
